const KeenSlider = window.KeenSlider

const { useReveal, useReset, useUpdate } = window.BAO.Carousel.plugins

class ProductCardGallery extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.plugins = [useReset(), useUpdate()]

    if (this.dataset.productCardGalleryUseReveal === 'true') {
      this.plugins.push(useReveal(this.els?.slide?.elements, true))
    }

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 768px)': {
            disabled: true,
          },
        },
      },
      this.plugins,
    )
  }
}

if (!customElements.get('product-card-gallery')) {
  customElements.define('product-card-gallery', ProductCardGallery)
}
